// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementProductRecommenderNamesResult = objectOf({
  recommenders: arrayOf(
    objectOf({
      id: string,
      name: string,
      state: string,
      fields: maybe(
        arrayOf(
          objectOf({
            name: string,
            type: string,
          })
        )
      ),
    })
  ),
});
